/**
 * In-place service category accordions (hair, nails, facial, massage, scalp).
 * Avoids native <details> scroll/navigation so mobile and desktop stay on the same view.
 */
(function () {
  function isOpen(item) {
    return item.hasAttribute('open');
  }

  function setOpen(item, trigger, open) {
    if (open) {
      item.setAttribute('open', '');
    } else {
      item.removeAttribute('open');
    }
    if (trigger) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  function bindAccordion(root, itemSelector, triggerSelector) {
    if (!root || root.dataset.magioAccordionBound === '1') return;
    root.dataset.magioAccordionBound = '1';

    root.querySelectorAll(itemSelector).forEach(function (item) {
      var trigger = item.querySelector(triggerSelector);
      if (!trigger) return;

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var willOpen = !isOpen(item);
        var top = item.getBoundingClientRect().top;

        if (willOpen) {
          root.querySelectorAll(itemSelector).forEach(function (other) {
            if (other !== item) {
              setOpen(other, other.querySelector(triggerSelector), false);
            }
          });
        }

        setOpen(item, trigger, willOpen);

        requestAnimationFrame(function () {
          var shift = item.getBoundingClientRect().top - top;
          if (Math.abs(shift) > 1) {
            window.scrollBy(0, shift);
          }
        });
      });
    });
  }

  function bindMore(root) {
    root.querySelectorAll('[data-magio-hair-more]').forEach(function (btn) {
      if (btn.dataset.magioMoreBound === '1') return;
      btn.dataset.magioMoreBound = '1';
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var panel = btn.closest('.magio-hair-services-content__media-copy');
        if (!panel) return;
        var desc = panel.querySelector('[data-magio-hair-desc]');
        if (!desc) return;
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var next = !expanded;
        btn.setAttribute('aria-expanded', next ? 'true' : 'false');
        desc.classList.toggle('is-clamped', !next);
        var expandLabel = btn.getAttribute('data-expand-label') || 'more +';
        var collapseLabel = btn.getAttribute('data-collapse-label') || 'less −';
        btn.textContent = next ? collapseLabel : expandLabel;
      });
    });
  }

  function boot(scope) {
    var base = scope || document;
    base.querySelectorAll('[data-magio-hair-accordion]').forEach(function (root) {
      bindAccordion(
        root,
        '.magio-hair-services-content__item',
        '.magio-hair-services-content__trigger'
      );
      bindMore(root);
    });
    base.querySelectorAll('[data-magio-pricing-accordion]').forEach(function (root) {
      bindAccordion(root, '.magio-hair-pricing__item', '.magio-hair-pricing__trigger');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
